import React from 'react';
import { FaTimes } from 'react-icons/fa';
import './tag.scss';

export const Tag = (props) => {
	return (
		<button className="tag">
			<span className="tag-label">{props.tag && props.tag.name}</span>
			<span className="tag-remove" onClick={props.onDelete}><FaTimes /></span>
		</button>
	)
};

export default Tag;
